import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { config } from '../../config';
import { SidebarContext } from '../../context/SidebarContext';
import { useContext } from 'react';

function SectionMenuLeft() {
    const { frontEndBaseUrl } = config;
    const { toggle, isSidebar, adminPermissions } = useContext(SidebarContext);
    const sidebarRef = useRef(null);

    const adminData = adminPermissions;

    let [isActiveUser, setIsActiveUser] = useState(false);
    let [isActiveRatings, setIsActiveRatings] = useState(false);
    let [isActiveSettings, setIsActiveSettings] = useState(false);
    let [isActiveBookings, setIsActiveBookings] = useState(false);
    let [isActiveCity, setIsActiveCity] = useState(false);
    let [isActivePayout, setIsActivePayout] = useState(false);
    let [isActiveNotification, setIsActiveNotification] = useState(false);
    let [isActiveSupport, setIsActiveSupport] = useState(false);
    let role = localStorage.getItem('adminRole');




    const toggleSubMenu = (state, func) => {
        func(!state);
    };

    // side bar close on outside clicking
    const handleClickOutside = (event) => {
        if (sidebarRef.current && !sidebarRef.current.contains(event.target) && window.innerWidth <= 768) {
            if (isSidebar) {
                toggle();
            };
        };
    };
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isSidebar]);

    // Side bar close on side nav link clicking
    const handleSidebarClose = () => {
        if (window.innerWidth <= 768) {
            toggle();
        };
    };

    return (
        <>

            {/* section-menu-left */}
            <div ref={sidebarRef} className="section-menu-left" style={{ left: isSidebar ? '0px' : '-100%' }}>
                <div className="box-logo" style={{ left: isSidebar ? '0px' : '-100%' }}>
                    <Link to="/" id="site-logo-inner">
                        <img className="" id="logo_header" alt="logo" src={`${frontEndBaseUrl}adminAssets/images/payLogo.jpg`} />
                    </Link>
                    <div className="button-show-hide" onClick={toggle}>
                        <i className="icon-menu-left"></i>
                    </div>
                </div>

                <div className="center">
                    <div className="center-item">
                        {
                            <>
                                <div className="center-heading">Main Home</div>
                                <ul className="menu-list">

                                    {(role === "admin" || (role === "sub-admin" && adminData?.dashboard_access)) && (
                                        <li className="menu-item">
                                            <Link to="/" className="menu-item-button">
                                                <div className="icon">
                                                    <i className="icon-menu"></i>
                                                </div>
                                                <div className="text" onClick={handleSidebarClose}>
                                                    Dashboard
                                                </div>
                                            </Link>
                                        </li>
                                    )}
                                    {(role === "admin" || (role === "sub-admin" && adminData?.fare_management)) && (
                                        <li className="menu-item">
                                            <Link to="/city/list" className="menu-item-button">
                                                <div className="icon">
                                                    <i className="fas fa-taxi"></i>
                                                </div>
                                                <div className="text" onClick={handleSidebarClose}>
                                                    City Fare Management
                                                </div>
                                            </Link>
                                        </li>
                                    )}
                                </ul>
                            </>

                        }
                    </div>


                    <div className="center-item">
                        {
                            (
                                (role === "admin") || (role === "sub-admin" && (adminData?.user_access || adminData?.driver_access || adminData?.sub_admin_access))) && (
                                <>
                                    <div className="center-heading">All page</div>
                                    <ul className="menu-list">
                                        <li className={`menu-item has-children ${isActiveUser ? 'active' : ''}`} onClick={() => toggleSubMenu(isActiveUser, setIsActiveUser)}>
                                            <Link className="menu-item-button">
                                                <div className="icon"><i className="icon-user"></i></div>
                                                <div className="text">Users</div>
                                            </Link>
                                            <ul className="sub-menu">
                                                {
                                                    (
                                                        (role === "admin") || (role === "sub-admin" && adminData?.user_access)) && (
                                                        <li className="sub-menu-item">
                                                            <Link to="/user" className="">
                                                                <div className="text" onClick={handleSidebarClose}>User List</div>
                                                            </Link>
                                                        </li>
                                                    )
                                                }
                                                {
                                                    (
                                                        (role === "admin") || (role === "sub-admin" && adminData?.driver_access)) && (
                                                        <li className="sub-menu-item">
                                                            <Link to="/driver" className="">
                                                                <div className="text" onClick={handleSidebarClose}>Driver List</div>
                                                            </Link>
                                                        </li>)
                                                }
                                                {
                                                    (
                                                        (role === "admin") || (role === "sub-admin" && adminData?.sub_admin_access)) && (
                                                        <li className="sub-menu-item">
                                                            <Link to="/admin/sub" className="">
                                                                <div className="text" onClick={handleSidebarClose}>Sub Admin List</div>
                                                            </Link>
                                                        </li>
                                                    )
                                                }

                                            </ul>
                                        </li>
                                    </ul>
                                </>
                            )
                        }
                        {
                            (
                                (role === "admin") || (role === "sub-admin" && (adminData?.ratings_access || adminData?.reviews_access || adminData?.offers_access || adminData?.referrals_access))) && (
                                <ul className="menu-list">
                                    <li className={`menu-item has-children ${isActiveRatings ? 'active' : ''}`} onClick={() => toggleSubMenu(isActiveRatings, setIsActiveRatings)}>
                                        <Link className="menu-item-button">
                                            <div className="icon"><i className="icon-star"></i></div>
                                            <div className="text">Rating & Review</div>
                                        </Link>
                                        <ul className="sub-menu">
                                            {
                                                ((role === "admin") || (role === "sub-admin" && adminData?.offers_access)) && (
                                                    <li className="sub-menu-item">
                                                        <Link to="/promo-codes" className="">
                                                            <div className="text" onClick={handleSidebarClose}>Promo Codes</div>
                                                        </Link>
                                                    </li>
                                                )
                                            }
                                            {
                                                ((role === "admin") || (role === "sub-admin" && adminData?.referrals_access)) && (
                                                    <li className="sub-menu-item">
                                                        <Link to="/referrals" className="">
                                                            <div className="text" onClick={handleSidebarClose}>Referrals</div>
                                                        </Link>
                                                    </li>
                                                )
                                            }
                                            {
                                                ((role === "admin") || (role === "sub-admin" && adminData?.reviews_access)) && (
                                                    <li className="sub-menu-item">
                                                        <Link to="/review" className="">
                                                            <div className="text" onClick={handleSidebarClose}>Reviews</div>
                                                        </Link>
                                                    </li>
                                                )
                                            }
                                            {/* {
                                                ((role === "admin") || (role === "sub-admin" && adminData?.offers_access)) && (
                                                    <li className="sub-menu-item">
                                                        <Link to="/offer" className="">
                                                            <div className="text" onClick={handleSidebarClose}>Offer</div>
                                                        </Link>
                                                    </li>
                                                )
                                            } */}
                                            
                                        </ul>
                                    </li>
                                </ul>
                            )
                        }
                        {
                            (
                                (role === "admin") || (role === "sub-admin" && (adminData?.settings_user_management || adminData?.settings_driver_management))) && (
                                <ul className="menu-list">
                                    <li className={`menu-item has-children ${isActiveSettings ? 'active' : ''}`} onClick={() => toggleSubMenu(isActiveSettings, setIsActiveSettings)}>
                                        <Link className="menu-item-button">
                                            <div className="icon"><i className="icon-settings"></i></div>
                                            <div className="text">Settings</div>
                                        </Link>
                                        <ul className="sub-menu">
                                            {/* {
                                                ((role === "admin") || (role === "sub-admin" && adminData?.settings_user_management)) && (
                                                    <li className="sub-menu-item">
                                                        <Link to="/settings/user">
                                                            <div className="text" onClick={handleSidebarClose}>User</div>
                                                        </Link>
                                                    </li>
                                                )
                                            } */}
                                            {
                                                ((role === "admin") || (role === "sub-admin" && adminData?.settings_driver_management)) && (
                                                    <li className="sub-menu-item">
                                                        <Link to="/settings/driver">
                                                            <div className="text" onClick={handleSidebarClose}>Driver</div>
                                                        </Link>
                                                    </li>
                                                )
                                            }
                                            {
                                                ((role === "admin") || (role === "sub-admin")) && (
                                                    <li className="sub-menu-item">
                                                        <Link to="/settings/picodes">
                                                            <div className="text" onClick={handleSidebarClose}>Unavailable Pincodes</div>
                                                        </Link>
                                                    </li>
                                                )
                                            }
                                        </ul>
                                    </li>
                                </ul>
                            )
                        }
                        {
                            (
                                (role === "admin") || (role === "sub-admin" && (adminData?.bookings_access || adminData?.cancellation_policy_access || adminData?.fare_management || adminData?.city_access))) && (
                                <ul className="menu-list">
                                    <li className={`menu-item has-children ${isActiveBookings ? 'active' : ''}`} onClick={() => toggleSubMenu(isActiveBookings, setIsActiveBookings)}>
                                        <Link className="menu-item-button">
                                            <div className="icon"><i className="icon-book"></i></div>
                                            <div className="text">Bookings</div>
                                        </Link>
                                        <ul className="sub-menu">
                                            {
                                                ((role === "admin") || (role === "sub-admin" && adminData?.bookings_access)) && (
                                                    <li className="sub-menu-item">
                                                        <Link to="/bookings">
                                                            <div className="text" onClick={handleSidebarClose}>Bookings</div>
                                                        </Link>
                                                    </li>
                                                )
                                            }

                                            {
                                                ((role === "admin") || (role === "sub-admin" && adminData?.cancellation_policy_access)) && (
                                                    <li className="sub-menu-item">
                                                        <Link to="/policy/cancellation">
                                                            <div className="text" onClick={handleSidebarClose}>Cancellation Policies</div>
                                                        </Link>
                                                    </li>
                                                )
                                            }

                                            {
                                                ((role === "admin") || (role === "sub-admin" && adminData?.fare_management)) && (
                                                    <li className="sub-menu-item">
                                                        <Link to="/city/list">
                                                            <div className="text" onClick={handleSidebarClose}>Fare Management</div>
                                                        </Link>
                                                    </li>
                                                )
                                            }
                                        </ul>
                                    </li>
                                </ul>
                            )
                        }

                        {
                            ((role === "admin") || (role === "sub-admin" && adminData?.city_access)) ? (
                                <ul className="menu-list">
                                    <li className={`menu-item has-children ${isActiveCity ? 'active' : ''}`} onClick={() => toggleSubMenu(isActiveCity, setIsActiveCity)}>
                                        <Link className="menu-item-button">
                                            <div className="icon"><i className="icon-map"></i></div>
                                            <div className="text">Locations</div>
                                        </Link>
                                        <ul className="sub-menu">
                                            <li className="sub-menu-item">
                                                <Link to="/city/list">
                                                    <div className="text" onClick={handleSidebarClose}>Cities</div>
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            ) : null
                        }

                        {
                            ((role === "admin") || (role === "sub-admin" && adminData?.payouts_access)) ? (
                                <ul className="menu-list">
                                    <li className={`menu-item has-children ${isActivePayout ? 'active' : ''}`} onClick={() => toggleSubMenu(isActivePayout, setIsActivePayout)}>
                                        <Link className="menu-item-button">
                                            <div className="icon"><i className="fa fa-exchange-alt"></i></div>
                                            <div className="text">Payouts</div>
                                        </Link>
                                        <ul className="sub-menu">
                                            {/* <li className="sub-menu-item">
                                                <Link to="/payouts/user">
                                                    <div className="text" onClick={handleSidebarClose}>User</div>
                                                </Link>
                                            </li> */}
                                            <li className="sub-menu-item">
                                                <Link to="/payouts">
                                                    <div className="text" onClick={handleSidebarClose}>List</div>
                                                </Link>
                                            </li>
                                            <li className="sub-menu-item">
                                                <Link to="/admin-wallet">
                                                    <div className="text" onClick={handleSidebarClose}>Admin Wallet</div>
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            ) : null
                        }

                        {
                            ((role === "admin") || (role === "sub-admin" && adminData?.notification_access)) ? (
                                <ul className="menu-list">
                                    <li className={`menu-item has-children ${isActiveNotification ? 'active' : ''}`} onClick={() => toggleSubMenu(isActiveNotification, setIsActiveNotification)}>
                                        <Link className="menu-item-button">
                                            <div className="icon">
                                                <i className="far fa-bell"></i>
                                            </div>
                                            <div className="text">Notification</div>
                                        </Link>
                                        <ul className="sub-menu">
                                            <li className="sub-menu-item">
                                                <Link to="/notification/templates">
                                                    <div className="text" onClick={handleSidebarClose}>Create Templates</div>
                                                </Link>
                                            </li>
                                            <li className="sub-menu-item">
                                                <Link to="/notification/list">
                                                    <div className="text" onClick={handleSidebarClose}>Send Notification</div>
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            ) : null
                        }

                        {((role === "admin") || (role === "sub-admin" && (adminData?.manage_FAQs || adminData?.manage_support))) && (
                            <ul className="menu-list">
                                <li className={`menu-item has-children ${isActiveSupport ? 'active' : ''}`} onClick={() => toggleSubMenu(isActiveSupport, setIsActiveSupport)}>
                                    <Link className="menu-item-button"><div className="icon"><i className="far fa-question-circle"></i></div><div className="text">FAQ & Queries</div></Link>
                                    <ul className="sub-menu">
                                        {((role === "admin") || adminData?.manage_FAQs) && <li className="sub-menu-item"><Link to="/faq"><div className="text" onClick={handleSidebarClose}>FAQs</div></Link></li>}
                                        {
                                                ((role === "admin") || (role === "sub-admin" && adminData?.queries_access)) && (
                                                    <li className="sub-menu-item">
                                                        <Link to="/queries" className="">
                                                            <div className="text" onClick={handleSidebarClose}>Queries</div>
                                                        </Link>
                                                    </li>
                                                )
                                            }
                                        {/* {((role === "admin") || adminData?.manage_support) && <li className="sub-menu-item"><Link to="/support"><div className="text" onClick={handleSidebarClose}>Support inbox</div></Link></li>} */}
                                    </ul>
                                </li>
                            </ul>
                        )}

                    </div>
                </div>
                {/* <div className="bot text-center">
                    <div className="wrap">
                        <div className="mb-20">
                            <img src={`${frontEndBaseUrl}adminAssets/images/menu-left/img-bot.png`} alt="img-bot" />
                        </div>
                        <div className="mb-20">
                            <h6>Hi, how can we help?</h6>
                            <div className="text">Contact us if you have any assistance, we will contact you as soon as possible</div>
                        </div>
                        <Link to="#" className="tf-button w-full">Contact</Link>
                    </div>
                </div> */}
            </div>
            {/* /section-menu-left */}

        </>
    )
}

export default SectionMenuLeft
